import { LabelConfiguration } from "../common/api/Models/LabelConfiguration";

export const isProductLabelConfiguration = (configuration: LabelConfiguration) => {
	return configuration.type === undefined || configuration.type === null || configuration.type === "Product";
};

export const isTagSheetLabelConfiguration = (configuration: LabelConfiguration) => {
	return configuration.type === "TagSheet";
};
